import { io } from 'socket.io-client';
import { useMemo } from 'react';


const useSocket = () => {
    const socket = useMemo(
        () =>
          io("https://kintify-backend.vercel.app", {
            withCredentials: true,
          }),
        []
      );
    return socket;    
}




export default useSocket;